export enum CommandType {
  SET_ZONE = 1,
  CLEAR_STATE = 2,
  EXIT_ZONE = 3,
}

export type Vector = { x: number; y: number; z: number };
